import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { QrGeneratorNavigatorCategories } from 'shared-library';
import { QrGeneratorNavigator } from '@app/store/models/qr-generator-navigator.interface';
import { FunctionsService } from '@app/modules/core/services/functions.service';

@Component({
  selector: 'app-shared-qr-preview-url',
  templateUrl: './shared-qr-preview-url.component.html',
  styleUrls: ['./shared-qr-preview-url.component.scss']
})
export class SharedQrPreviewUrlComponent implements OnInit {

  create_mode = !window.location.href.includes("edit")

  session_info: SessionInfo
  data: QrGeneratorNavigator
  private subscriptions: Subscription[] = []
  url_to_show = "http://brandqrcodes.com"

  constructor(
    private coreService: CoreService,
    public functionService: FunctionsService
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => {
      this.session_info = si
      if (this.create_mode) {
        this.data = this.session_info?.qr_generating?.drafts?.find(d => d.selected_category === QrGeneratorNavigatorCategories.URL)
      } else {
        this.data = this.session_info?.qr_generating?.updating
      }
      if (this.data?.url_data?.url) {
        this.url_to_show = this.data.url_data.url
      }
    }))
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }

}
